import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import { Report } from "./pages/Report";
import { UserManangement } from "./pages/UserManangement";
import { ManageUserManangement } from "./pages/component/ManageUserManangement";

import { MasterCountryVat } from "./pages/MasterCountryVat";
import { CreateMasterCountryVat } from "./pages/component/Create/CreateMasterCountryVat";
import { EditMasterCountryVat } from "./pages/component/Edit/EditMasterCountryVat";

import { MasterTCO } from "./pages/MasterTCO";
import { CreateMasterTCO } from "./pages/component/Create/CreateMasterTCO";
import { EditMasterTCO } from "./pages/component/Edit/EditMasterTCO";

import { MasterModel } from "./pages/MasterModel";
import { CreateMasterModel } from "./pages/component/Create/CreateMasterModel";
import { EditMasterModel } from "./pages/component/Edit/EditMasterModel";

import { MasterFuel } from "./pages/MasterFuel";
import { ImportMasterFuel } from "./pages/component/Import/ImportMasterFuel";

import { MasterProd } from "./pages/MasterProd";
import { ImportMasterProd } from "./pages/component/Import/ImportMasterProd";

import { MasterMainten } from "./pages/MasterMainten";
import { ImportMasterMainten } from "./pages/component/Import/ImportMasterMainten";

import { MasterResale } from "./pages/MasterResale";
import { ImportMasterResale } from "./pages/component/Import/ImportMasterResale";

import { NewsManagement } from "./pages/NewsManagement"; 
import { EditNewsImage } from "./pages/component/Edit/EditNewsImage"; 
import { EditNews } from "./pages/component/Edit/EditNews";
import { CreateNews } from "./pages/component/Create/CreateNews";
import { CreateNewsImage } from "./pages/component/Create/CreateNewsImage";

import { ProductManagement } from "./pages/ProductManagement";
import { EditProductManagement } from "./pages/component/Edit/EditProductManagement";
import {CreateProductManagement} from "./pages/component/Create/CreateProductManagement"

import { ContractUsManagement } from "./pages/ContractManagement";
import { EditContractUSManagement } from "./pages/component/Edit/EditContractUS";
import { CreateContractus } from "./pages/component/Create/CreateContractus";

import { Presentation } from "./pages/Presentation";
import { EditPresentation } from "./pages/component/Edit/EditPresentation";
import { CreatePresentation } from "./pages/component/Create/CreatePresentation";

import { MachineManagement } from "./pages/MachineManagement";
import { EditMachineManagement } from "./pages/component/Edit/EditMachineManagement";
import { CreateMachineManagement } from "./pages/component/Create/CreateMachineManagement";

import { ClassManagement } from "./pages/ClassManagement";
import { EditClassManagement } from "./pages/component/Edit/EditClassManagement";
import { CreateClassManagement } from "./pages/component/Create/CreateClassManagement";

import { SpecCompareManagement } from "./pages/SpecCompareManagement";
import {CreatSpecCompareManagement} from "./pages/component/Create/CreatSpecCompareManagement"
import { EditSpecCompareManagement } from "./pages/component/Edit/EditSpecCompareManagement";

import { NotificationManagement } from "./pages/NotificationManagement";

import { ItemManagement } from "./pages/ItemsManagement";
import { EditItemManagement } from "./pages/component/Edit/EditItemManagement"

import { CreateItemManagement } from "./pages/component/Create/CreatetemManagement";

import { GroupItem } from "./pages/GroupItem";
import { EditGroupItemManagement } from "./pages/component/Edit/EditGroupItem";
import { CreateGroupItemManagement } from "./pages/component/Create/CreateGroupItem";

import { ItemKeyManagement } from "./pages/ItemsKeyManagement";
import { EditItemKey } from "./pages/component/Edit/EditItemKey";
import { CreateItemKey } from "./pages/component/Create/CreateItemKey";

import { EditItemImage } from "./pages/component/Edit/EditItemImage";
import { CreateItemImage } from "./pages/component/Create/CreateItemImage";
import { EditItemDetail } from "./pages/component/Edit/EditItemDetail";
import { EditDetail } from "./pages/component/Edit/EditDetail";
import { CreateDetail } from "./pages/component/Create/CreateDetail";

import { PreTypeManagement } from "./pages/PreTypeManagement";
import { CreatePreType } from "./pages/component/Create/CreatePreType";
import { EditPreType } from "./pages/component/Edit/EditPreType";
import { PreTypeList } from "./pages/PreTypeList";
import { CreatePrefile } from "./pages/component/Create/CreatePrefile";
import { EditPrefile } from "./pages/component/Edit/EditPrefile";

import { SpecGroupManagement } from "./pages/SpecGroupManagement";
import { CreatespecGroup } from "./pages/component/Create/CreatespecGroup";
import { EditspecGroup } from "./pages/component/Edit/EditspecGroup";
import { EditSpecCompare } from "./pages/component/Edit/EditSpecCompare";
import { SpecKeyManagement } from "./pages/SpecKeyManagement";
import { EditspecKey } from "./pages/component/Edit/EditspecKey";
import { CreatespecKey } from "./pages/component/Create/CreatespecKey";
import { EditSpec } from "./pages/component/Edit/EditSpec";
import { CreateSpec } from "./pages/component/Create/CreateSpec";
import { FeedbackLog } from "./pages/FeedbackLog";

import { User} from "./pages/User"

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {<Redirect exact from="/" to="/dashboard" />}
        <ContentRoute path="/Dashboard" component={DashboardPage} />
        <ContentRoute path="/Report" component={Report} />

        <ContentRoute path="/UserManangement" component={UserManangement} />
        <ContentRoute path="/ManageUserManangement" component={ManageUserManangement}/>

        <ContentRoute path="/MasterCountryVat" component={MasterCountryVat} />
        <ContentRoute path="/CreateMasterCountryVat" component={CreateMasterCountryVat}/>
        <ContentRoute path="/EditMasterCountryVat" component={EditMasterCountryVat} />

        <ContentRoute path="/MasterTCO" component={MasterTCO} />
        <ContentRoute path="/CreateMasterTCO" component={CreateMasterTCO} />
        <ContentRoute path="/EditMasterTCO" component={EditMasterTCO} />

        <ContentRoute path="/MasterModel" component={MasterModel} />
        <ContentRoute path="/CreateMasterModel" component={CreateMasterModel} />
        <ContentRoute path="/EditMasterModel" component={EditMasterModel} />

        <ContentRoute path="/MasterFuel" component={MasterFuel} />
        <ContentRoute path="/ImportMasterFuel" component={ImportMasterFuel} />

        <ContentRoute path="/MasterProd" component={MasterProd} />
        <ContentRoute path="/ImportMasterProd" component={ImportMasterProd} />

        <ContentRoute path="/MasterMainten" component={MasterMainten} />
        <ContentRoute path="/ImportMasterMainten" component={ImportMasterMainten} />

        <ContentRoute path="/MasterResale" component={MasterResale} />
        <ContentRoute path="/ImportMasterResale" component={ImportMasterResale} />
        
        <ContentRoute path="/NewsManagement" component={NewsManagement} />
        <ContentRoute path="/EditNewsManagement" component={EditNews} />
        <ContentRoute path="/CreateNewsManagement" component={CreateNews} />
        <ContentRoute path="/EditNewsImage" component={EditNewsImage} />
        <ContentRoute path="/CreateNewsImage" component={CreateNewsImage} />


        <ContentRoute path="/ProductManagement" component={ProductManagement} />
        <ContentRoute path="/EditProductManagement" component={EditProductManagement} />
        <ContentRoute path="/CreateProductManagement" component={CreateProductManagement} />

        <ContentRoute path="/ContractUsManagement" component={ContractUsManagement} />
        <ContentRoute path="/EditContractUSManagement" component={EditContractUSManagement} />
        <ContentRoute path="/CreateContractusManagement" component={CreateContractus} />

        <ContentRoute path="/Presentation" component={Presentation} />
        <ContentRoute path="/EditPresentation" component={EditPresentation} />
        <ContentRoute path="/CreatePresentation" component={CreatePresentation} />

        <ContentRoute path="/MachineManagement" component={MachineManagement} />
        <ContentRoute path="/EditMachineManagement" component={EditMachineManagement} />
        <ContentRoute path="/CreateMachineManagement" component={CreateMachineManagement} />
        
        <ContentRoute path="/ClassManagement" component={ClassManagement} />
        <ContentRoute path="/EditClassManagement" component={EditClassManagement} />
        <ContentRoute path="/CreateClassManagement" component={CreateClassManagement} />

        <ContentRoute path="/SpecCompareManagement" component={SpecCompareManagement} />
        <ContentRoute path="/CreatSpecCompareManagement" component={CreatSpecCompareManagement} />
        <ContentRoute path="/EditSpecCompareManagement" component={EditSpecCompareManagement} />

        <ContentRoute path="/NotificationManagement" component={NotificationManagement} />
        
        <ContentRoute path="/ItemManagement" component={ItemManagement} />
        <ContentRoute path="/EditItemManagement" component={EditItemManagement} />
        <ContentRoute path="/CreateItemManagement" component={CreateItemManagement} />

        <ContentRoute path="/GroupItem" component={GroupItem} />
        <ContentRoute path="/EditGroupItemManagement" component={EditGroupItemManagement} />
        <ContentRoute path="/CreateGroupItemManagement" component={CreateGroupItemManagement} />

        <ContentRoute path="/ItemKeyManagement" component={ItemKeyManagement} />
        <ContentRoute path="/EditItemKey" component={EditItemKey} />
        <ContentRoute path="/CreateItemKey" component={CreateItemKey} />

        <ContentRoute path="/EditItemImage" component={EditItemImage} />
        <ContentRoute path="/CreateItemImage" component={CreateItemImage} />
        <ContentRoute path="/EditItemDetail" component={EditItemDetail} />
        <ContentRoute path="/EditDetail" component={EditDetail} />
        <ContentRoute path="/CreateDetail" component={CreateDetail} />

        <ContentRoute path="/PreTypeManagement" component={PreTypeManagement} />
        <ContentRoute path="/CreatePreType" component={CreatePreType} />
        <ContentRoute path="/EditPreType" component={EditPreType} />
        <ContentRoute path="/PreTypeList" component={PreTypeList} />
        <ContentRoute path="/CreatePrefile" component={CreatePrefile} />
        <ContentRoute path="/EditPrefile" component={EditPrefile} />

        <ContentRoute path="/specGroupManagement" component={SpecGroupManagement} />
        <ContentRoute path="/CreatespecGroup" component={CreatespecGroup} />
        <ContentRoute path="/EditspecGroup" component={EditspecGroup} />
        <ContentRoute path="/EditSpecCompare" component={EditSpecCompare} />
        <ContentRoute path="/SpecKeyManagement" component={SpecKeyManagement} />
        <ContentRoute path="/EditspecKey" component={EditspecKey} />
        <ContentRoute path="/CreatespecKey" component={CreatespecKey} />
        <ContentRoute path="/EditSpec" component={EditSpec} />
        <ContentRoute path="/CreateSpec" component={CreateSpec} />
        <ContentRoute path="/FeedbackLog" component={FeedbackLog} />
        <ContentRoute path="/User" component={User} />


                
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
